import React from 'react';
import { Palette } from 'Palette';

export const SidebarToneContext = React.createContext<keyof typeof Palette>('tone4');
export const useSidebarTone = () => React.useContext(SidebarToneContext);
